import React, { useState } from 'react';

const CASES = [
  { case_num:"A-22130-52787", status:"Certified-Expired", received:"2022-05-27", decided:"2023-02-01", employer:"DELL MARKETING LP", job:"Senior Advisor, Product Marketing", city:"Round Rock", state:"TEXAS", soc:"Market Research Analysts and Marketing Specialists", level:"II", pw_wage:62421, offered:122661, country:"PERU", visa:"H-1B" },
  { case_num:"A-22126-51632", status:"Certified-Expired", received:"2022-05-13", decided:"2023-03-06", employer:"DELL MARKETING LP", job:"Senior Advisor, Competitive Intelligence", city:"Round Rock", state:"TEXAS", soc:"Market Research Analysts and Marketing Specialists", level:"III", pw_wage:77771, offered:121621, country:"CHINA", visa:"H-1B" },
  { case_num:"A-22291-41132", status:"Certified-Expired", received:"2022-12-22", decided:"2023-12-06", employer:"DELL MARKETING LP", job:"Consultant, Field Marketing", city:"Round Rock", state:"TEXAS", soc:"Marketing Managers", level:"III", pw_wage:153920, offered:155089, country:"UNITED KINGDOM", visa:"L-1" },
  { case_num:"A-22167-73029", status:"Certified", received:"2022-07-15", decided:"2023-04-10", employer:"DELL MARKETING LP", job:"Senior Manager, Product Marketing", city:"Round Rock", state:"TEXAS", soc:"Marketing Managers", level:"IV", pw_wage:185661, offered:185661, country:"SLOVAKIA", visa:"L-1" },
  { case_num:"A-22160-68893", status:"Certified", received:"2022-07-14", decided:"2023-06-02", employer:"DELL MARKETING LP", job:"Consultant, Sales Planning & Strategy", city:"Round Rock", state:"TEXAS", soc:"Operations Research Analysts", level:"III", pw_wage:84822, offered:139033, country:"ROMANIA", visa:"H-1B" },
  { case_num:"A-22293-42855", status:"Certified", received:"2022-10-26", decided:"2023-09-07", employer:"DELL MARKETING LP", job:"Consultant, Product Offer Management", city:"Round Rock", state:"TEXAS", soc:"Market Research Analysts and Marketing Specialists", level:"IV", pw_wage:93101, offered:111300, country:"FRANCE", visa:"L-1" },
];

function levelColor(l) {
  if (l==='I'||l==='II') return { bg:'#FCEBEB', color:'#A32D2D' };
  if (l==='III') return { bg:'#FAEEDA', color:'#633806' };
  if (l==='IV') return { bg:'#EAF3DE', color:'#27500A' };
  return { bg:'#F0F4FF', color:'#1A3A5C' };
}

function statusColor(s) {
  if (s==='Certified') return { bg:'#EAF3DE', color:'#27500A' };
  if (s==='Denied') return { bg:'#FCEBEB', color:'#A32D2D' };
  return { bg:'#FAEEDA', color:'#633806' };
}

function Flag({ c }) {
  const gap = (c.offered - c.pw_wage).toLocaleString();
  if (c.level==='I'||c.level==='II') return (
    <div style={{ borderLeft:'3px solid #C0392B', background:'#FCEBEB',
      borderRadius:'0 6px 6px 0', padding:'10px 14px', fontSize:'12px',
      color:'#501313', lineHeight:1.6, marginTop:'10px' }}>
      <strong>⚠ Wage level concern:</strong> Filed at Level {c.level} — entry/qualified — despite a senior title paying ${c.offered.toLocaleString()}. Prevailing wage floor was only ${c.pw_wage.toLocaleString()}, a gap of ${gap}. SOC classification may not reflect actual seniority.
    </div>
  );
  if (c.level==='III') return (
    <div style={{ borderLeft:'3px solid #D4870A', background:'#FAEEDA',
      borderRadius:'0 6px 6px 0', padding:'10px 14px', fontSize:'12px',
      color:'#633806', lineHeight:1.6, marginTop:'10px' }}>
      <strong>Level III — acceptable.</strong> Offer of ${c.offered.toLocaleString()} is ${gap} above the ${c.pw_wage.toLocaleString()} prevailing wage. Verify SOC code matches your actual duties.
    </div>
  );
  return (
    <div style={{ borderLeft:'3px solid #1A9068', background:'#EAF3DE',
      borderRadius:'0 6px 6px 0', padding:'10px 14px', fontSize:'12px',
      color:'#173404', lineHeight:1.6, marginTop:'10px' }}>
      <strong>Level IV — strong filing.</strong> No red flags detected.
    </div>
  );
}

export default function PERMLookup() {
  const [emp, setEmp] = useState('');
  const [job, setJob] = useState('');
  const [searched, setSearched] = useState(false);
  const [results, setResults] = useState([]);

  function search() {
    const r = CASES.filter(c =>
      (!emp || c.employer.toLowerCase().includes(emp.toLowerCase())) &&
      (!job || c.job.toLowerCase().includes(job.toLowerCase()))
    );
    setResults(r);
    setSearched(true);
  }

  const inp = { width:'100%', padding:'0 12px', height:'40px',
    border:'1px solid #E8ECF2', borderRadius:'8px', fontSize:'14px',
    background:'#fff', color:'#2C3E50', outline:'none', fontFamily:'inherit' };

  return (
    <div style={{ maxWidth:'900px', margin:'0 auto', padding:'3rem 2rem' }}>
      <div style={{ marginBottom:'2rem' }}>
        <div style={{ fontSize:'11px', letterSpacing:'2.5px', textTransform:'uppercase',
          color:'#1A9068', marginBottom:'6px' }}>Free · Public DOL Data</div>
        <h1 style={{ fontSize:'2rem', fontWeight:500, color:'#0B1F3A', marginBottom:'8px' }}>
          Look up your PERM case
        </h1>
        <p style={{ fontSize:'14px', color:'#8A9BB0', lineHeight:1.7 }}>
          Search the Department of Labor's public PERM disclosure data. See your wage level,
          prevailing wage, and whether your employer filed correctly — free, no signup needed.
        </p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr auto',
        gap:'8px', marginBottom:'24px' }}>
        <input style={inp} placeholder="Employer name (e.g. Dell Marketing LP)"
          value={emp} onChange={e => setEmp(e.target.value)}
          onKeyDown={e => e.key==='Enter' && search()} />
        <input style={inp} placeholder="Job title (partial match)"
          value={job} onChange={e => setJob(e.target.value)}
          onKeyDown={e => e.key==='Enter' && search()} />
        <button onClick={search} style={{ height:'40px', padding:'0 24px',
          background:'#1A9068', color:'#fff', border:'none', borderRadius:'8px',
          fontSize:'14px', fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>
          Search →
        </button>
      </div>

      {searched && (
        <div>
          <div style={{ fontSize:'13px', color:'#8A9BB0', marginBottom:'12px' }}>
            {results.length} case{results.length !== 1 ? 's' : ''} found
          </div>
          {results.length === 0 ? (
            <div style={{ textAlign:'center', padding:'3rem', color:'#8A9BB0',
              fontSize:'14px', background:'#fff', borderRadius:'10px',
              border:'1px solid #E8ECF2' }}>
              No cases found. Try a broader search.
            </div>
          ) : results.map(c => (
            <div key={c.case_num} style={{ background:'#fff', border:'1px solid #E8ECF2',
              borderRadius:'10px', padding:'16px', marginBottom:'10px' }}>
              <div style={{ display:'flex', justifyContent:'space-between',
                alignItems:'flex-start', marginBottom:'12px', flexWrap:'wrap', gap:'8px' }}>
                <div>
                  <div style={{ fontSize:'15px', fontWeight:500, color:'#0B1F3A' }}>{c.job}</div>
                  <div style={{ fontSize:'12px', color:'#8A9BB0', marginTop:'2px' }}>
                    {c.employer} · {c.city}, {c.state}
                  </div>
                </div>
                <div style={{ display:'flex', gap:'6px', flexWrap:'wrap' }}>
                  {[
                    { label:c.status, ...statusColor(c.status) },
                    { label:`Level ${c.level}`, ...levelColor(c.level) },
                  ].map(b => (
                    <span key={b.label} style={{ background:b.bg, color:b.color,
                      display:'inline-block', padding:'3px 9px', borderRadius:'4px',
                      fontSize:'11px', fontWeight:500 }}>{b.label}</span>
                  ))}
                </div>
              </div>
              <div style={{ display:'grid',
                gridTemplateColumns:'repeat(auto-fill,minmax(150px,1fr))',
                gap:'8px', marginBottom:'4px' }}>
                {[
                  { label:'Prevailing wage', val:`$${c.pw_wage.toLocaleString()}` },
                  { label:'Offered salary', val:`$${c.offered.toLocaleString()}` },
                  { label:'SOC classification', val:c.soc },
                  { label:'Country · visa', val:`${c.country} · ${c.visa}` },
                  { label:'Filed → decided', val:`${c.received} → ${c.decided}` },
                  { label:'Case number', val:c.case_num },
                ].map(f => (
                  <div key={f.label} style={{ background:'#F7F8FA',
                    borderRadius:'6px', padding:'8px 10px' }}>
                    <div style={{ fontSize:'10px', color:'#8A9BB0', marginBottom:'3px' }}>{f.label}</div>
                    <div style={{ fontSize:'12px', fontWeight:500, color:'#2C3E50',
                      wordBreak:'break-word' }}>{f.val}</div>
                  </div>
                ))}
              </div>
              <Flag c={c} />
            </div>
          ))}
        </div>
      )}

      <div style={{ marginTop:'2rem', padding:'1rem', background:'#F0F4FF',
        borderRadius:'8px', fontSize:'12px', color:'#1A3A5C', lineHeight:1.6 }}>
        <strong>Data source:</strong> U.S. DOL OFLC PERM Disclosure Data (public domain).
        Demo data shown — full dataset coming soon.
      </div>
    </div>
  );
}